<form [formGroup]="form" (ngSubmit)="login()" class="account-migration-root" *transloco="let t">
  <app-epson-logo></app-epson-logo>
  <app-label isBig>{{t('welcome-new-epson-rewards')}}</app-label>
  <app-paragraph>{{t('account-migration-login-info')}}</app-paragraph>
  <app-input [label]="t('email-address')" [control]="email" type="email"></app-input>
  <app-input [label]="t('temporary-password')" type="password" [control]="password"></app-input>
  <app-label isBig>{{t('create-new-password')}}</app-label>
  <app-paragraph>{{t('account-migration-new-password-info')}}</app-paragraph>
  <app-input [label]="t('new-password')" [control]="newPassword" type="password"></app-input>
  <app-input [label]="t('confirm-new-password')" [control]="confirmNewPassword" type="password"></app-input>
  <app-form-feedback-list [abstractControl]="newPassword"></app-form-feedback-list>
  <app-primary-button [abstractControl]="form" type="submit">{{t('change-password')}}</app-primary-button>
  <app-epson-powered></app-epson-powered>
</form>
